import { Route } from 'react-router';
import { Page } from '@roc/feature-app-core';
import { LenderLicensesDashboard } from '../components';

export const getLenderLicensesRoutesConfig = (basePath: string, baseUrl: string) => {
  return {
    lenderLicensesDashboard: {
      path: `${basePath}/lender-licenses/dashboard`,
      url: `${baseUrl}/lender-licenses/dashboard`,
      documentTitle: 'Lenders Licenses',
    },
  };
};

export const getLenderLicensesRoutes = (basePath: string, baseUrl: string) => {
  const config = getLenderLicensesRoutesConfig(basePath, baseUrl);

  return {
    lenderLicensesDashboard: (
      <Route exact path={config.lenderLicensesDashboard.path}>
        <Page routeDefinition={config.lenderLicensesDashboard}>
          <LenderLicensesDashboard />
        </Page>
      </Route>
    ),
  };
};
